export const postBackgroundTypes: string[] = [
  'white',
  'aqua',
  'grey',
  'red',
  'orange',
  'green',
  'blue',
  'purple',
  'yellow',
];
